import { GemsApi_StoneSymmetry } from '@/graphql/api'
import { computed, type ComputedRef, type Ref, toValue } from 'vue'
import { findOrder } from '@/domain/stone/search/findOrder'

const ordered: GemsApi_StoneSymmetry[] = [
    GemsApi_StoneSymmetry.Ideal,
    GemsApi_StoneSymmetry.Excellent,
    GemsApi_StoneSymmetry.VeryGood,
    GemsApi_StoneSymmetry.Good,
    GemsApi_StoneSymmetry.Fair,
] as const

function findSymmetryOrder(code: GemsApi_StoneSymmetry) {
    return findOrder(ordered, code)
}

export function useOrderedSymmetry(
    shapes: Ref<GemsApi_StoneSymmetry[]> | (() => GemsApi_StoneSymmetry[])
): ComputedRef<GemsApi_StoneSymmetry[]> {
    return computed(() => {
        return toValue(shapes).sort(
            (a: GemsApi_StoneSymmetry, b: GemsApi_StoneSymmetry) => {
                const orderA = findSymmetryOrder(a)
                const orderB = findSymmetryOrder(b)

                return orderA - orderB
            }
        )
    })
}
